import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Sparkles } from 'lucide-react';

import { Button } from '@/components/ui/button';

export function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="border-t border-border">
      <div className="mx-auto max-w-6xl px-4 py-16 md:py-24">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-violet-600 via-fuchsia-500 to-orange-400 px-6 py-14 text-center text-white shadow-2xl shadow-fuchsia-500/20 md:px-16 md:py-20">
          <div
            aria-hidden
            className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,hsl(0_0%_100%/0.25),transparent_55%)]"
          />
          <div
            aria-hidden
            className="absolute -bottom-32 -right-20 size-80 rounded-full bg-white/10 blur-3xl"
          />
          <div className="relative mx-auto flex max-w-2xl flex-col items-center gap-5">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-medium backdrop-blur">
              <Sparkles className="h-3.5 w-3.5" />
              {t('home.hero.trust1')}
            </span>
            <h2 className="font-display text-3xl font-extrabold tracking-tight md:text-4xl">
              {t('home.finalCta.title')}
            </h2>
            <p className="text-base text-white/85 md:text-lg">{t('home.finalCta.subtitle')}</p>
            <Button
              asChild
              size="lg"
              className="mt-2 bg-white text-violet-700 shadow-lg hover:bg-white/95"
            >
              <Link to="/editor">
                {t('home.finalCta.cta')}
                <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
